// extracted by mini-css-extract-plugin
export default {"eskiShahar":"eskiShahar_eskiShahar__gCaYJ"};